import * as ents from '@attain-apps/entities'
import * as store from '@attain-apps/fe/web/main/lib/store'
import { TypeAsserter } from '@attain-apps/type-guards'
import * as rxjs from 'rxjs'

import type * as dynamicEcs from '../../../../../dynamic-ecs'
import type * as currentRendering from '../../../feature'
import type * as actions from '../../actions'
import type { Feature } from '../feature'

/**
 * Triggers bootstrap action when a table widget renders successfully.
 */
export const triggerEcBootstrap = store.effects.create(
  (
    feature: Feature,
    currentRendering: currentRendering.Feature,
    actionsFeature: actions.Feature,
    dynamicEcsFeature: dynamicEcs.Feature,
  ) =>
    feature.actions.render.success.observe().pipe(
      rxjs.withLatestFrom(currentRendering.selectors.context.asObservable),
      rxjs.map(
        ([
          {
            data: {
              request: { ref },
              response: { rendering },
            },
          },
          pageRenderingContext,
        ]) => {
          // Ensure the rendering context is available
          // Or skip the effect
          if (!pageRenderingContext) {
            return store.effects.SKIP
          }

          // Creates an action handler for the table widget
          const createHandler = (
            partialSource: string,
            actionRef: ents.core.mosaic.Action.Ref,
          ) =>
            actionsFeature.createActionHandler(
              `Widget.${ref.id}.Table.${partialSource}`,
              {
                ...pageRenderingContext,
                actionRef,

                widget: {
                  id: TypeAsserter.validate(
                    rendering.id,
                    TypeAsserter.assertIsNotNullish,
                  ),
                  refId: ref.id,
                },
              },
            )

          return rendering.type === ents.core.mosaic.Widget.Type.Table
            ? dynamicEcsFeature.actions.bootstrap
                .from('triggerEcBootstrap (effect)')
                .create({
                  actionHandlers: {
                    onClick: actionRef =>
                      createHandler(`Row.Clicked`, actionRef),
                    overflow: actionRef =>
                      createHandler(
                        // TODO: get better name something like Action.Ref.getName(actionRef)
                        `Overflow.${actionRef.name ?? ''}.Clicked`,
                        actionRef,
                      ),
                  },
                  ref,
                  rendering,
                })
            : store.effects.SKIP
        },
      ),
    ),
)
